<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2 mt-5 content" v-html="content"></div>
    </div>

    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <div id="map"></div>
      </div>
    </div>
    <div class="row mb-lg-5 mt-5">
      <div class="col-md-7  col-lg-5 offset-lg-2" v-if="!isFormSended">
        <form @submit="sendForm($event)">
          <div class="form-group ">
            <label for="name">{{formFields.email_title}}</label>
            <input
                type="email"
                class="form-control"
                id="name"
                :placeholder="formFields.email_placeholder"
                v-model="feedback.mail"
            >
          </div>
          <div class="form-group">
            <label for="email">{{formFields.name_title}}</label>
            <input
                type="text"
                class="form-control"
                id="email"
                :placeholder="formFields.name_placeholder"
                v-model="feedback.name"
            >
          </div>
          <div class="form-group">
            <label for="message">{{formFields.message_title}}</label>
            <textarea
                class="form-control"
                id="message"
                rows="3"
                v-model="feedback.message"
            ></textarea>
          </div>
          <button v-if="isFormValid" class="btn btn-outline-primary btn-lg" >
            {{formFields.button_text}}
          </button>
        </form>
      </div>
      <div class="col-md-7 col-lg-5 offset-lg-2 d-flex" v-else>
        <h4 class="align-self-center">
          {{formFields.thnx_text}}
        </h4>
      </div>
      <div class="col-lg-3 col-md-5">
        <h2 class="mt-0">{{ contacts.contacts_title}}</h2>
        <address v-html="contacts.contacts_adress">
        </address>
        <address>
          <abbr :title="contacts.contacts_phone_title">{{contacts.contacts_phone_title}}:</abbr>
          <a :href="`tel:${contacts.contacts_phone}`"> {{ contacts.contacts_phone}}</a>
          <br>
          <abbr title="Email">Email:</abbr>
          <a :href="`mailto:${contacts.contacts_email}`"> {{ contacts.contacts_email}}</a>
        </address>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/api';
import filterObject from '@/util/lang';
import store from '@/store';

export default {
  name: 'Contacts',
  data() {
    return {
      content: '',
      contacts: {},
      isErrorOccured: false,
      isFormSended: false,
      formFields: {},
      feedback: {
        name: '',
        mail: '',
        message: '',
      },
    };
  },
  created() {
    if (!window.google) {
      const gmaps = document.createElement('script');
      gmaps.setAttribute(
        'src',
        'https://maps.googleapis.com/maps/api/js?key=AIzaSyDr8e80o0cryLZ9uhYMtfwCxZgCuDF6wC0',
      );
      gmaps.addEventListener('load', () => {
        const office = { lat: 34.687348, lng: 33.051992 };
        const map = new window.google.maps.Map(document.getElementById('map'), {
          zoom: 15,
          center: office,
        });
        const marker = new window.google.maps.Marker({ position: office, map });
      });
      document.head.appendChild(gmaps);
    }
    this.getContent();
    store.watch(
      state => state.lang,
      () => {
        this.getContent();
      },
    );
  },
  computed: {
    isFormValid() {
      return this.feedback.message && this.feedback.mail && this.feedback.name;
    },
  },
  methods: {
    getContent() {
      Api.getContentContacts()
        .then(page => filterObject(page, store.getters.lang))
        .then(localizedPage => {
          this.content = localizedPage.content;
        });
      Api.getFormFields()
        .then(formFields => filterObject(formFields, store.getters.lang))
        .then(localizedformFields => {
          this.formFields = localizedformFields;
        });
      Api.getContentMain()
        .then(page => filterObject(page, store.getters.lang))
        .then(localizedPage => {
          this.contacts = localizedPage;
        });
    },
    sendForm(event) {
      event.preventDefault();
      Api.sendFom({
        form: {
          name: this.feedback.name,
          mail: this.feedback.mail,
          message: this.feedback.message,
        },
      }).then(({ request }) => {
        if (request.status === 200) {
          this.isFormSended = true;
        } else {
          this.isFormSended = true;
          this.isErrorOccured = true;
        }
      });
    },
  },
};
</script>

<style scoped>
#map {
  height: 400px;
}
</style>
